"use client";

import { usePathname } from "next/navigation";

import { usePlatformAuth } from "@/hooks/use-platform-auth";
import {
  MARKETING_FOOTER_LINKS,
  MARKETING_NAV_LINKS,
} from "@/lib/marketing/nav-links";
import {
  isPricingNavTarget,
  resolvePricingDestination,
} from "@/lib/platform/pricing-destination";

export type ResolvedMarketingNavItem = {
  name: string;
  link: string;
  isCurrent?: boolean;
};

export type ResolvedMarketingFooterItem = {
  label: string;
  href: string;
  isCurrent?: boolean;
};

function resolvePricingFields(
  href: string,
  isAuthenticated: boolean,
  pathname: string,
): { href: string; isCurrent: boolean } {
  if (!isPricingNavTarget(href)) {
    return { href, isCurrent: pathname === href };
  }

  const dest = resolvePricingDestination({ isAuthenticated, pathname });
  return { href: dest.href, isCurrent: dest.isCurrent };
}

export function useMarketingNavLinks(): ResolvedMarketingNavItem[] {
  const pathname = usePathname();
  const { isAuthenticated } = usePlatformAuth();

  return MARKETING_NAV_LINKS.map((item) => {
    const resolved = resolvePricingFields(item.link, isAuthenticated, pathname);
    return {
      name: item.name,
      link: resolved.href,
      isCurrent: resolved.isCurrent,
    };
  });
}

export function useMarketingFooterLinks(): ResolvedMarketingFooterItem[] {
  const pathname = usePathname();
  const { isAuthenticated } = usePlatformAuth();

  return MARKETING_FOOTER_LINKS.map((item) => {
    const resolved = resolvePricingFields(item.href, isAuthenticated, pathname);
    return {
      label: item.label,
      href: resolved.href,
      isCurrent: resolved.isCurrent,
    };
  });
}
